import React from 'react';
import { Container } from './styles';
import { ReactComponent as HelpIcon } from '../../../../assets/novosicones/help_outline.svg';
import TooltipStandard from '../../../TooltipStandard';
import formatCurrent from '../../../../Utils/formatCurrent';
import { ReactComponent as ReceiptLongIcon } from '../../../../assets/novosicones/Financeiro/receipt_long.svg';
import { ReactComponent as AttachMoneyIcon } from '../../../../assets/novosicones/Financeiro/attach_money.svg';
function CardAntecipacaoParcelas({
  isWithoutDiscount,
  text,
  value,
  tooltipText,
  tema,
}) {
  const icon = isWithoutDiscount ? <ReceiptLongIcon /> : <AttachMoneyIcon />;
  const formatedValue = formatCurrent(value);
  const colorValue = isWithoutDiscount ? tema?.accent : tema?.primaryColor;

  return (
    <TooltipStandard title={tooltipText} placement='bottom'>
      <Container color={colorValue}>
        <div className='icon'>{icon}</div>
        <span className='text'>{text}</span>
        <div className='container-value-help'>
          <span className='value'>{formatedValue}</span>
          <HelpIcon />
        </div>
      </Container>
    </TooltipStandard>
  );
}

export default CardAntecipacaoParcelas;
